/**
 * 项目全局配置
 * */
module.exports = {
  // api_url: '/php/',
  api_url: process.env.VUE_APP_API_URL + '/api/', // 旧版接口
  new_api_url: process.env.VUE_APP_NEW_API_URL + (process.env.NODE_ENV !== 'production' ? '/api2/' : '/api/'), // 新版接口
  // api_url: 'http://xlj.mvbook.cn/php/', // 正式地址
  // api_url: 'http://www.zgjiaxiaoyun.com/php/', // 正式地址

  // 扫码登录
  appid: process.env.VUE_APP_APPID,
  redirect_uri: process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PATH,

  // 七牛上传文件地址
  q_api_url: 'opening/upload.qupload',
  // 上传文件地址域名
  host_path: 'http://qiniu.iexue100.com/',
  localStorageKey: 'glkt_web',
  ERR_OK: 200,

  //适配rem 不是1时进行适配 dev模式时修改后重新运行生效
  remUnit: 1,
};
